import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Autocomplete, Button, Input, Modal, Toggle } from "src/components";
import { RootState } from "src/context/store";
import { getInvoiceChangeValidationV1, getInvoiceDetails, getTextractData } from "src/services/invoice-api";
import { useToast } from "src/hooks/useToast";
import { editInvoice } from "src/services/invoice-api";
import { useDispatch } from "react-redux";
import { invoiceActions } from "src/context/invoice-slice";
import { useEventStatus } from "src/hooks/useEventStatus";
import { getOrderProductsForMapping } from "src/services/order-api";
import { fineGrainedPermissionsKeys } from "src/constants/permission";
import { getTwoMonthsAgoDate } from "src/utils/utils";
import useDebounceLeading from "src/hooks/useDebounceLeading";
import EscalateToMaster from "./InvoiceEntryCards/EscalateToMaster";
import { validateInvoiceNumber } from "./invoice-constants"; //M10-11021

const defaultTableData = [
  { label: "Company", master: "", invoice: "" },
  { label: "Division Name", master: "", invoice: "" },
  { label: "Invoice No.", master: "", invoice: "" },
  { label: "Invoice Date", master: "", invoice: "", invoiceDate: "" },
  { label: "FUID", master: "", invoice: "" },
  // { label: "Reference ID", master: "", invoice: "" },
  { label: "Doctor name", master: "", invoice: "" },
  { label: "Link Type", master: "", invoice: "" },
  { label: "Counter Code", master: "", invoice: "" },
  { label: "Counter Name", master: "", invoice: "" },
  { label: "Clinic/Hospital", master: "", invoice: "" },
  { label: "Order Code", master: "", invoice: "" },
  { label: "Stockist", master: "", invoice: "" },
  { label: "Stockist Code", master: "", invoice: "" },
  { label: "Pharmacy name", master: "", invoice: "" },
  { label: "Address", master: "", invoice: "" },
  { label: "City", master: "", invoice: "" },
  { label: "MCI No.", master: "", invoice: "" },
  { label: "MCI Validated", master: "", invoice: "" },
  { label: "DL Number*", master: "", invoice: "" },
  { label: "DL Present", master: "", invoice: "" },
  { label: "GST No.*", master: "", invoice: "" },
  { label: "GST Applicability", master: "", invoice: "" },  //M10-11546
  { label: "E-Inv.Applicability", master: "", invoice: "" },
  { label: "QR/IRN", master: "", invoice: "" },
  { label: "IRN Number", master: "", invoice: "" },
  { label: "Entered By", master: "", invoice: "" },
  { label: "Approved By", master: "", invoice: "" },
  { label: "Net Amount", master: "", invoice: "" },
  { label: "E-Inv Category", master: "", invoice: "" },
];

const InvoiceHeader = () => {
  const [tableData, setTableData] = useState<any[]>(defaultTableData);
  const { invoiceDetails, invoiceMappingOrderedProducts, invoiceMappingOrderData } = useSelector((state: RootState) => state.invoice);
  const [invoiceNumber, setInvoiceNumber] = useState<string>(invoiceDetails?.invoice?.invoice_number);
  const [netAmount, setNetAmount] = useState<number>(invoiceDetails?.invoice?.net_amount);
  const [invoiceDate, setInvoiceDate] = useState<string>(invoiceDetails?.invoice?.new_invoice_date);
  const [dlValidated, setdlValidated] = useState<string>(invoiceDetails?.invoice?.dl_validated === true ? "Yes" : "No");
  const [mciValid, setMciValid] = useState<string>(invoiceDetails?.invoice?.mci_validated === true ? "Yes" : "No");
  const [gstStatus, setGstStatus] = useState<string>(invoiceDetails?.invoice?.gst_validated === true ? "Yes" : "No");
  const [StampSeal, setStampSeal] = useState<boolean>(invoiceDetails?.invoice?.stamp_and_seal_validated);
  const [category1, setCategory1] = useState<boolean>(invoiceDetails?.invoice?.is_category_1);
  const [netAmountValidate, setNetAmountValidate] = useState<boolean>(invoiceDetails?.invoice?.net_amount_validated); //M10-11051
  const [qrIRN, setQrIRN] = useState<string>(invoiceDetails?.invoice?.e_inv_ref_type);
  const [irnNumber, setIrnNumber] = useState<string>(invoiceDetails?.invoice?.irn);
  const { toast } = useToast();
  const dispatch = useDispatch();
  const { withEventCheck } = useEventStatus();
  const [isLoading, setIsLoading] = useState(false);
  const [escalateToMasterOpen, setEscalateToMasterOpen] = useState<boolean>(false);

  //M10-11086
  const [IRNValidation, setIRNValidation] = useState<boolean>(
    invoiceDetails?.invoice?.e_inv_ref_type === "IRN" ||
    invoiceDetails?.invoice?.e_inv_ref_type === "BOTH"
  );
  const [IRNExempt, setIRNExempt] = useState<any>(invoiceDetails?.invoice?.irn_exempt);
  //M10-11086

  const catTwoAndThree =
    invoiceDetails?.einvack_type_code === "Upload E-Inv Aknowledgement Copy separately" ||
    invoiceDetails?.einvack_type_code === "Periodic Bulk Upload of E-Invoice";

  const company_code = invoiceDetails?.company_code;

  const fetchTextractData = async () => {
    try {
      const response = await getTextractData(invoiceDetails?.fuid_no, company_code);
      const textractHeaderData = response?.data?.data?.data?.header;
      const newTableData = [
        { label: "Company", master: invoiceDetails?.company_name, invoice: textractHeaderData?.company_name },
        {
          label: "Division Name",
          master: invoiceMappingOrderData?.flatMap((item: any) => item?.division_name)?.join(", ") || "",
          invoice: invoiceMappingOrderData?.flatMap((item: any) => item?.division_name)?.join(", ") || "",
        },
        { label: "Invoice no.", master: invoiceDetails?.invoice?.invoice_number, invoice: textractHeaderData?.invoice_number },
        {
          label: "Invoice date",
          master: moment(invoiceDetails?.invoice?.new_invoice_date).format("MMMM Do YYYY, h:mm a"),
          invoice: moment(textractHeaderData?.created_date).format("MMMM Do YYYY, h:mm a"),
          invoiceDate: invoiceDetails?.invoice?.new_invoice_date,
        },
        { label: "FUID", master: invoiceDetails?.fuid_no, invoice: textractHeaderData?.fuid },
        // { label: "Reference ID", master: "", invoice: "" },
        { label: "Doctor name", master: "", invoice: "" },
        { label: "Link Type", master: invoiceDetails?.link_type, invoice: "" },
        { label: "Counter Code", master: invoiceDetails?.counter_code, invoice: textractHeaderData?.counter_code },
        { label: "Counter Name", master: invoiceDetails?.counter_name, invoice: textractHeaderData?.counter_name },
        { label: "Clinic/Hospital", master: invoiceDetails?.counter_clinic_name, invoice: textractHeaderData?.clinic_name },
        {
          label: "Order Code",
          master: invoiceDetails?.orderCodes?.map((code: any) => code?.order_code).join(", ") || "-",
          invoice: textractHeaderData?.order_code,
        },

        { label: "Stockist", master: invoiceDetails?.stockist_name, invoice: textractHeaderData?.stockist_name },
        { label: "Stockist Code", master: invoiceDetails?.stockist_medvol_code, invoice: textractHeaderData?.stockist_code },
        { label: "Pharmacy name", master: invoiceDetails?.pharmacy_name, invoice: "" },
        { label: "Address", master: invoiceDetails?.counter_address, invoice: "" },
        { label: "City", master: invoiceDetails?.state_district_city?.split(",")[2], invoice: "" },
        { label: "MCI No.", master: invoiceDetails?.counter_mci_number, invoice: "" },
        { label: "MCI Validated", master: invoiceDetails?.mci_validated, invoice: "" },
        { label: "DL Number*", master: invoiceDetails?.counter_dl_number, invoice: "" },
        { label: "DL Present", master: invoiceDetails?.invoice?.dl_validated, invoice: "" },
        { label: "GST No.*", master: invoiceDetails?.counter_gst_number, invoice: textractHeaderData?.retailer_gst },
        { label: "GST Applicability", master: invoiceDetails?.counter_gst_status ? "Yes" : "No", invoice: "" }, //M10-11546
        { label: "E-Inv.Applicability", master: invoiceDetails?.is_einv_applicable === true ? "Yes" : "No", invoice: "" },
        { label: "QR/IRN", master: invoiceDetails?.invoice?.e_inv_ref_type, invoice: "" },
        { label: "IRN Number", master: invoiceDetails?.invoice?.irn, invoice: "" },
        { label: "Entered By", master: invoiceDetails?.invoice?.entered_by, invoice: "" },
        { label: "Approved By", master: invoiceDetails?.invoice?.approved_by, invoice: "" },
        ...(invoiceDetails?.is_einv_applicable === true ? [
          { label: "E-Inv Category", master: invoiceDetails?.einvack_type_code == "Upload IRN/BarCode along with Invoice" ? "Category 1" : (invoiceDetails?.einvack_type_code == "Upload E-Inv Aknowledgement Copy separately" ? "Category 2" : "Category 3"), invoice: "" },
        ] : []),
        { label: "Net Amount", master: "", invoice: "" },
        ...(invoiceDetails?.stamp_and_seal_required === true ? [
          { label: "Stamp & Sign Status", master: "", invoice: "" },
          { label: "E-Inv", master: "", invoice: "" }
        ] : [])
      ];
      setTableData(newTableData);
    } catch (error: any) {
      console.log(error);
      toast({ description: error?.response?.data?.message || "Error fetching textract data", variant: "destructive" });
    }
  };
  const isRequestInProgress = useRef(false);

  const handleSubmitInvoiceHeader = useDebounceLeading(async () => {
    if (isRequestInProgress.current) return;
    isRequestInProgress.current = true;
    try {
      //M10-11021
      let vertifyResult = validateInvoiceNumber(invoiceNumber)
      if (!vertifyResult.valid) {
        toast({ description: vertifyResult?.error, variant: "destructive" });
        return;
      }
      //M10-11021
      if (invoiceDate == undefined || invoiceDate == "" || invoiceDate == null || invoiceDate == " ") {
        toast({ description: "Select Invoice Date before updating", variant: "destructive" });
        return;
      }

      //M10-11134
      if (new Date(invoiceDate) > new Date()) {
        toast({ description: "Invoice date cannot be in the future", variant: "destructive" });
        return;
      }
      //M10-11134

      if (((!qrIRN || qrIRN == null) && invoiceDetails?.is_einv_applicable == true && !catTwoAndThree) || (category1 && (!qrIRN || qrIRN == null))) {
        toast({ description: "Add QR/IRN", variant: "destructive" });
        return;
      }

      //M10-11086
      if (!IRNExempt) {
        if (
          (irnNumber.trim() !== 'IMAGE FILE' &&
            invoiceDetails?.is_einv_applicable === true &&
            !catTwoAndThree &&
            qrIRN &&
            qrIRN !== "QR" &&
            irnNumber.trim().length !== 64) || (
            irnNumber.trim() !== 'IMAGE FILE' &&
            category1 &&
            qrIRN &&
            qrIRN !== "QR" &&
            irnNumber.trim().length !== 64)
        ) {
          toast({ description: "IRN should be 64 digit", variant: "destructive" });
          return;
        }
      }

      if (netAmount == undefined || netAmount == null || netAmount == 0) {
        toast({ description: "Enter Valid Net Amount", variant: "destructive" });
        return;
      }

      if (!netAmountValidate) {
        toast({ description: "Validate Net Amount as YES", variant: "destructive" });
        return;
      }

      // if (((qrIRN == "IRN" || qrIRN == "BOTH") && (irnNumber == " " || irnNumber == ""))) {
      //   toast({ description: "Add IRN Number", variant: "destructive" });
      //   return;
      // }

      // if (gstStatus == "Yes" && !invoiceDetails?.counter_gst_number?.trim()) {
      //   toast({ description: "GST not validated", variant: "destructive" });
      //   return;
      // }
      if (gstStatus == "No" && invoiceDetails?.counter_gst_status) {
        toast({ description: "Validate GST Applicability as YES", variant: "destructive" });  //M10-11546
        return;
      }
      // if (dlValidated == "Yes" && !invoiceDetails?.counter_dl_number?.trim()) {
      //   toast({ description: "DL not validated", variant: "destructive" });
      //   return;
      // }
      // if (mciValid == "Yes" && !invoiceDetails?.counter_mci_number?.trim()) {
      //   toast({ description: "MCI not validated", variant: "destructive" });
      //   return;
      // }

      // if (invoiceDetails?.link_type == "DRDS" && mciValid == "Yes" && !invoiceDetails?.counter_mci_number?.trim()) {
      //   toast({ description: "MCI not validated", variant: "destructive" });
      //   return;
      // }
      if (invoiceDetails?.link_type == "DRDS" && mciValid == "No" && invoiceDetails?.counter_mci_number?.trim()) {
        toast({ description: "Validate MCI Validated as YES", variant: "destructive" });
        return;
      }
      // if (invoiceDetails?.link_type == "DRDS" && mciValid == "No" && !invoiceDetails?.counter_mci_number?.trim()) {
      //   toast({ description: "MCI not validated", variant: "destructive" });
      //   return;
      // }
      // if (invoiceDetails?.link_type == "DRDS" && gstStatus == "Yes" && !invoiceDetails?.counter_gst_number?.trim()) {
      //   toast({ description: "GST not validated", variant: "destructive" });
      //   return;
      // }
      // if (
      //   (invoiceDetails?.link_type == "DRAPH" || invoiceDetails?.link_type == "INDPH-PH" || invoiceDetails?.link_type == "INDPH-HS") &&
      //   dlValidated == "Yes" &&
      //   (!invoiceDetails?.counter_dl_number?.trim() || invoiceDetails?.counter_dl_number?.trim() == undefined)
      // ) {
      //   toast({ description: "DL not validated", variant: "destructive" });
      //   return;
      // }
      // if (
      //   (invoiceDetails?.link_type == "DRAPH" || invoiceDetails?.link_type == "INDPH-PH" || invoiceDetails?.link_type == "INDPH-HS") &&
      //   dlValidated == "No" &&
      //   (!invoiceDetails?.counter_dl_number?.trim() || invoiceDetails?.counter_dl_number?.trim() == undefined)
      // ) {
      //   toast({ description: "DL not validated", variant: "destructive" });
      //   return;
      // }
      if (
        (invoiceDetails?.link_type == "DRAPH" || invoiceDetails?.link_type == "INDPH-PH" || invoiceDetails?.link_type == "INDPH-HS") &&
        dlValidated == "No" &&
        invoiceDetails?.counter_dl_number?.trim()
      ) {
        toast({ description: "Validate DL Present as YES", variant: "destructive" });
        return;
      }
      // if (
      //   (invoiceDetails?.link_type == "DRAPH" || invoiceDetails?.link_type == "INDPH-PH" || invoiceDetails?.link_type == "INDPH-HS") &&
      //   gstStatus == "Yes" &&
      //   (!invoiceDetails?.counter_gst_number?.trim() || invoiceDetails?.counter_gst_number?.trim() == undefined)
      // ) {
      //   toast({ description: "GST not validated", variant: "destructive" });
      //   return;
      // }
      setIsLoading(true);
      const currentDate = new Date(invoiceDate);
      const currentYear = currentDate.getFullYear();
      const financialYearStart = new Date(currentDate.getMonth() >= 3 ? currentYear : currentYear - 1, 3, 1);

      const invoiceAccYear = financialYearStart.getFullYear();

      const payloadToValidateInV1 = {
        cmpstockistcode: invoiceDetails?.company_stockist_code,
        invoicenumber_searchcolumn: invoiceNumber,
        invoice_accyear: invoiceAccYear,
        company_code: invoiceDetails?.company_code,
      };
      const response = await getInvoiceChangeValidationV1(payloadToValidateInV1);
      if (response?.data?.success !== "success") {
        toast({ description: response?.data?.message, variant: "destructive" });
        setIsLoading(false);
        return;
      }
      const payload = {
        data: {
          invoice_status: invoiceDetails?.fileStatusHdr?.fuid_status_shortcode,
          invoice_id: invoiceDetails?.invoice?.invoice_id,
          invoice_number: invoiceNumber?.trim(),
          u_code: invoiceDetails?.invoice?.u_code,
          new_invoice_date: invoiceDate,
          stockist_invoice_attachment_id: invoiceDetails?.stockist_invoice_attachment_id,
          stockist_id: invoiceDetails?.stockist_id,
          ...(qrIRN?.trim() !== "" && { e_inv_ref_type: qrIRN }),
          irn: qrIRN == "IRN" || qrIRN == "BOTH" ? irnNumber.trim() : "",
          gst_validated: gstStatus == "Yes" ? true : false,
          dl_validated: dlValidated == "Yes" ? true : false,
          mci_validated: mciValid == "Yes" ? true : false,
          counter_gst_number: invoiceDetails?.counter_gst_number || "",
          counter_dl_number: invoiceDetails?.counter_dl_number || "",
          counter_mci_number: invoiceDetails?.counter_mci_number || "",
          net_amount: `${Number(netAmount).toFixed(2)}`,
          header_edit: true,
          // invoice_num_modified: invoiceDetails?.invoice?.invoice_number?.trim() !== invoiceNumber?.trim(),
          invoice_num_modified: true,
          stamp_and_seal_validated: StampSeal,
          is_category_1: category1,
          net_amount_validated: netAmountValidate, //M10-11051
          irn_exempt: IRNExempt, //M10-11086
          counter_data_validation:
            invoiceDetails?.invoice?.dl_validated !== (dlValidated == "Yes" ? true : false) ||
            invoiceDetails?.invoice?.gst_validated !== (gstStatus == "Yes" ? true : false) ||
            invoiceDetails?.invoice?.mci_validated !== (mciValid == "Yes" ? true : false),
        },
        primary_key: invoiceDetails?.invoice?.invoice_id,
        event_type: "INVOICE_EDIT",
      };

      const res = await editInvoice(payload, company_code);

      const responseEvent = await withEventCheck(
        () => {
          return getInvoiceDetails(invoiceDetails?.stockist_invoice_attachment_id as string, false, company_code);
        },
        res?.data?.data?.invoice?.eventStreamCreated?.streamId
      );
      dispatch(invoiceActions?.setInvoiceDetails(responseEvent?.data?.data));
      toast({ description: "Invoice updated successfully", variant: "default" });
    } catch (error: any) {
      console.log(error);
      toast({ description: error?.responseEvent?.data?.message || error?.response?.data?.message || "Failed to update invoice", variant: "destructive" });
    } finally {
      setIsLoading(false);
      isRequestInProgress.current = false;
    }
  }, 1000);

  const fetchOrderedProducts = async () => {
    try {
      const resp = await getOrderProductsForMapping(invoiceDetails?.orderCodes?.map((code: any) => code?.order_code).join(", "), company_code); //M10-10771
      // dispatch(invoiceActions?.setInvoiceMappingOrderedProducts(resp?.data?.data?.flatMap((item: any) => item?.orderProducts)));
      const productsWithDivision = resp?.data?.data?.flatMap(
        (item: any) =>
          item?.orderProducts?.map((product: any) => ({
            ...product,
            item_division: item?.division_name,
          }))
      );
      dispatch(invoiceActions?.setInvoiceMappingOrderedProducts(productsWithDivision));
      dispatch(invoiceActions?.setInvoiceMappingOrderData(resp?.data?.data));
    } catch (error: any) {
      toast({ description: error?.response?.data?.message || "Error fetching division codes", variant: "destructive" });
      console.log(error);
    }
  };

  const handleInputChange = (e: any) => {
    const inputValue = e.target.value;
    setInvoiceNumber(inputValue);
  };
  const handleNetAmount = (e: any) => {
    const inputValue = e.target.value;
    setNetAmount(inputValue);
  };

  useEffect(() => {
    if (invoiceMappingOrderedProducts?.length === 0) {
      fetchOrderedProducts();
    }
    fetchTextractData();
  }, []);

  // useEffect(() => {
  //   if (invoiceMappingOrderedProducts?.length > 0) {
  //     fetchTextractData();
  //   }
  // }, [invoiceMappingOrderedProducts]);

  return (
    <div>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          textAlign: "left",
          border: "1px solid #ccc",
        }}
        className="mt-10"
      >
        <thead>
          <tr className="text-sm bg-[#F1F1F1]">
            <th style={{ padding: "10px", borderBottom: "1px solid #ccc" }}></th>
            <th style={{ padding: "10px", borderBottom: "1px solid #ccc" }}>As per Master</th>
            <th style={{ padding: "10px", borderBottom: "1px solid #ccc" }}>Generated Invoice</th>
            <th style={{ padding: "10px", borderBottom: "1px solid #ccc" }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((row, index) => (
            <tr key={index} className="w-full">
              <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }} className="w-1/4 text-gray-500">
                <span
                  className={`ml-2 text-sm ${row.label === "Pharmacy name" || row.label === "Counter Name"
                    ? "font-bold"
                    : "font-normal"
                    }`}
                >
                  {row.label}
                </span>
              </td>
              <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }} className="w-1/4 text-sm">
                {row.master}
              </td>
              <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }} className="w-1/4 text-sm">
                {row.invoice}
                {row?.label === "Net Amount" && (
                  <div className="w-[70%]">
                    <Input
                      enableArrows={false}
                      showIcon={false}
                      placeholder={row?.label}
                      type="number"
                      value={netAmount}
                      onChange={handleNetAmount}
                      className="w-full py-1 text-left border border-gray-300 rounded-lg"
                    />
                  </div>
                )}
              </td>
              <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }} className="w-1/4 text-sm">
                {row?.label === "Invoice no." && (
                  <div className="w-[100%]">
                    <Input
                      enableArrows={false}
                      showIcon={false}
                      placeholder={row?.label}
                      type="text"
                      value={row?.invoice || invoiceNumber}
                      onChange={handleInputChange}
                      className="w-full py-1 text-left border border-gray-300 rounded-lg"
                    />
                  </div>
                )}
                {row?.label === "Net Amount" && (
                  <div className="w-[100%]">
                    <Toggle
                      checked={netAmountValidate}
                      onChange={(e: any) => {
                        setNetAmountValidate(e === true);
                      }}
                    />
                  </div>
                )}
                {row?.label === "Invoice date" && (
                  <Input
                    enableArrows={false}
                    showIcon={false}
                    placeholder={row?.label}
                    type="date"
                    value={row?.invoiceDate ? row.invoiceDate.split("T")[0] : invoiceDate ? invoiceDate.split("T")[0] : ""}
                    max={new Date().toISOString().split("T")[0]}
                    min={getTwoMonthsAgoDate()}
                    className="w-full py-1 text-left border border-gray-300 rounded-lg"
                    onChange={(e: any) => {
                      const dateValue = e.target.value;
                      // Parse the date from the input (expected format: YYYY-MM-DD)
                      const [year, month, day] = dateValue.split("-").map(Number);
                      // Get current UTC time parts
                      const now = new Date();
                      const utcHours = now.getUTCHours();
                      const utcMinutes = now.getUTCMinutes();
                      const utcSeconds = now.getUTCSeconds();
                      const utcMilliseconds = now.getUTCMilliseconds();
                      // Create a new Date using the selected date and current UTC time
                      const selectedDate = new Date(Date.UTC(year, month - 1, day, utcHours, utcMinutes, utcSeconds, utcMilliseconds));
                      const formattedDate = selectedDate.toISOString(); // Final UTC ISO string
                      setInvoiceDate(formattedDate);
                    }}
                  />
                )}
                {row?.label == "GST Applicability" && ( //M10-11546
                  <div className="w-[60%]">
                    {invoiceDetails?.counter_gst_status &&
                      <Toggle
                        checked={gstStatus == "Yes"}
                        onChange={(e: any) => {
                          setGstStatus(e === true ? "Yes" : "No");
                        }}
                      />}
                  </div>
                )}
                {row?.label == "DL Present" && (
                  <div className="w-[60%]">
                    {tableData.find((d) => d.label === "DL Number*")?.master &&
                      <Toggle
                        checked={dlValidated == "Yes"}
                        onChange={(e: any) => {
                          setdlValidated(e === true ? "Yes" : "No");
                        }}
                      />}
                  </div>
                )}
                {row?.label == "MCI Validated" && (
                  <div className="w-[60%]">
                    {tableData.find((d) => d.label === "MCI No.")?.master && <Toggle
                      checked={mciValid == "Yes"}
                      onChange={(e: any) => {
                        setMciValid(e === true ? "Yes" : "No");
                      }}
                    />}
                  </div>
                )}
                {row?.label == "QR/IRN" && (
                  <div className="w-[60%] flex items-center gap-2">
                    <Autocomplete
                      inputClassName="relative"
                      placeholder={row?.label}
                      defaultValue={qrIRN}
                      suggestionList={[
                        { key: "QR", value: "QR" },
                        { key: "IRN", value: "IRN" },
                        { key: "BOTH", value: "BOTH" },
                      ]}
                      disabled={
                        !category1 && (
                          //invoiceDetails?.is_einv_applicable == false ||
                          [6, 8].includes(invoiceDetails?.fileStatusHdr?.fuid_status_id)
                        )
                      }
                      onSelectionChange={(e: any) => {
                        if (e === null) {
                          setQrIRN("");
                          return;
                        }
                        setQrIRN(e.value);
                        //M10-11086
                        if (e.value === 'IRN' || e.value === 'BOTH') {
                          setIRNValidation(true)
                        } else {
                          setIRNValidation(false)
                        }
                      }}
                      displayKey="key"
                    />
                  </div>
                )}
                {/* //M10-11086 */}
                {row?.label == "QR/IRN" && IRNValidation && (
                  <div className="flex items-center gap-2 m-3">
                    <span className="inline-flex items-center gap-2">
                      IRN Exemption :  <Toggle
                        checked={IRNExempt}
                        onChange={(e: any) => {
                          setIRNExempt(e === true);
                        }}
                      />
                    </span>
                  </div>
                )}
                {(qrIRN === "IRN" || qrIRN === "BOTH") && row?.label === "IRN Number" && (
                  <div className="w-full mt-2">
                    <Input
                      enableArrows={false}
                      showIcon={false}
                      placeholder="IRN Number"
                      type="text"
                      value={irnNumber}
                      disabled={
                        (invoiceDetails?.is_einv_applicable == false ||
                          invoiceDetails?.fileStatusHdr?.fuid_status_id === 8 ||
                          invoiceDetails?.fileStatusHdr?.fuid_status_id === 6) &&
                        category1 == false
                      }
                      onChange={(e: any) => setIrnNumber(e.target.value)}
                      className="w-full py-1 text-left border border-gray-300 rounded-lg"
                    />
                  </div>
                )}
                {row?.label == "Stamp & Sign Status" && invoiceDetails?.stamp_and_seal_required && (
                  <div className="w-[60%]">
                    <Toggle
                      checked={StampSeal}
                      onChange={(e: any) => {
                        setStampSeal(e === true);
                      }}
                    />
                  </div>
                )}
                {row?.label == "E-Inv" && invoiceDetails?.stamp_and_seal_required && (
                  <div className="w-[60%]">
                    <Toggle
                      checked={category1}
                      onChange={(e: any) => {
                        setCategory1(e === true);
                        if (invoiceDetails?.is_einv_applicable === false && e === false) {
                          setQrIRN("");
                          setIrnNumber("")
                        }
                      }}
                    />
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="flex justify-end mt-14 gap-x-2">
        <Button onClick={() => setEscalateToMasterOpen(true)} disabled={isLoading} className="font-normal bg-gray-200 border border-gray-300">
          Escalate to Master
        </Button>
        <Button
          disabled={isLoading || isRequestInProgress.current}
          isLoading={isLoading}
          loaderSize="small"
          onClick={handleSubmitInvoiceHeader}
          className="font-normal text-white bg-primary"
          module={fineGrainedPermissionsKeys.INVOICE["UPDATE/APPROVEINVOICE"].module}
          action={fineGrainedPermissionsKeys.INVOICE["UPDATE/APPROVEINVOICE"].action}
        >
          Update Invoice
        </Button>
      </div>
      <Modal isOpen={escalateToMasterOpen} isHeader={false} onCloseModal={() => setEscalateToMasterOpen(false)}>
        <EscalateToMaster
          onSuccess={() => {
            // navigate("/transactions/invoice/0");
          }}
          onCloseModal={() => setEscalateToMasterOpen(false)}
        />
      </Modal>
    </div>
  );
};

export default InvoiceHeader;
